import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import { Badge } from "@components/ui/badge";

interface Props {
  count: number;
  className?: string;
}

export const PendingCountBadge = ({ count, className }: Props) => {
  if (count === 0) return null;
  return (
    <Badge variant="destructive" className={cn("h-5 min-w-5 shrink-0 px-1.5 text-xs", className)}>
      {count}
    </Badge>
  );
};
